import { render, staticRenderFns } from "./IconFoxcoin.vue?vue&type=template&id=2a983c28&"
import script from "./IconFoxcoin.vue?vue&type=script&lang=js&"
export * from "./IconFoxcoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports